import { makeStyles } from '@material-ui/styles';

const useTableButtonStyle = makeStyles({
    root: {
        minWidth: '42px',
        width: '42px',
        height: '42px',
        borderRadius: '50%'
    },
});

export default useTableButtonStyle;